import { SeedingFloatingActionBar } from '../common/SeedingFloatingActionBar';
import type { SeedingPrimaryCta } from '../types';

interface RecruitApplyActionBarProps {
  cta: SeedingPrimaryCta;
  onAction: (action: SeedingPrimaryCta['primary']['action']) => void;
  /** 외부(약관 필수 동의 미완료 등) 사유로 primary 버튼을 비활성으로 강제 OR. */
  primaryDisabled?: boolean;
}

export const RecruitApplyActionBar = ({
  cta,
  onAction,
  primaryDisabled = false,
}: RecruitApplyActionBarProps) => {
  if (cta.mode === 'single') {
    return (
      <SeedingFloatingActionBar
        mode="single"
        variant={cta.variant ?? 'default'}
        primary={{
          label: cta.primary.label,
          disabled: (cta.primary.disabled ?? false) || primaryDisabled,
          onClick: () => onAction(cta.primary.action),
        }}
      />
    );
  }
  return (
    <SeedingFloatingActionBar
      mode="dual"
      variant={cta.variant ?? 'default'}
      primary={{
        label: cta.primary.label,
        disabled: (cta.primary.disabled ?? false) || primaryDisabled,
        onClick: () => onAction(cta.primary.action),
      }}
      secondary={{
        label: cta.secondary.label,
        disabled: cta.secondary.disabled ?? false,
        onClick: () => onAction(cta.secondary.action),
      }}
    />
  );
};
